import type { IModel } from '../stores/model';
import type { ITransition } from '../stores/model/metamodel/transition';

/**
 * Custom hook that returns the transition between a source state and a target
 * state (given by ids).
 */
export function useTransitionForStates(
  model: IModel,
  sourceStateId: string,
  targetStateId: string
): ITransition | undefined {
  const sourceState = model.metamodel.getStateById(sourceStateId);
  if (sourceState != null) {
    return sourceState.outgoingTransitions.find(t => t.targetState.id === targetStateId);
  }
}
